import { actionConstants } from './actionConstants';
import noti from './toast';
import { get, post, put, _delete } from './method';

export default {
  getUnits,
  getSpecificUnit,
  createUnit,
  editUnit,
  deleteUnit,
};

function getUnits() {
  return async (dispatch, getState) => {
    dispatch({ type: actionConstants.GETTING_UNITS });
    return await get('app/units?Sorting=units%20asc&MaxResultCount=1000')
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_UNITS_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        dispatch({
          type: actionConstants.GET_UNITS_FAILURE,
          data: error.response.data.error.message,
        });
        throw error.response.data.error.message;
      });
  };
}

function getSpecificUnit(unitId) {
  return async (dispatch, getState) => {
    dispatch({ type: actionConstants.GETTING_UNITS });
    return await get(`app/units/${unitId}`)
      .then((resp) => {
        dispatch({
          type: actionConstants.GET_UNIT_SUCCESS,
          data: resp,
        });
      })
      .catch((error) => {
        noti.error(error.message);
        dispatch({
          type: actionConstants.GET_UNIT_FAILURE,
          data: error.message,
        });
      });
  };
}

function createUnit(_params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    return await post('app/units', params)
      .then((resp) => {
        noti.success(`Unit is created`);
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        throw error.response.data.error.message;
      });
  };
}

function editUnit(unitId, _params) {
  let params = {
    body: _params,
  };
  return async (dispatch) => {
    return await put(`app/units/${unitId}`, params)
      .then((resp) => {
        noti.success(`Unit is updated`);
        return resp;
      })
      .catch((error) => {
        noti.error(error.response.data.error.message);
        throw error.response.data.error.message;
      });
  };
}

function deleteUnit(id) {
  return async (dispatch, getState) => {
    return await _delete(`app/units/${id}`)
      .then((resp) => {
        noti.success('Unit is deleted');
        return resp;
      })
      .catch((error) => {
        noti.error(error.message);
        return error;
      });
  };
}
